module.exports = __webpack_public_path__ + "img/0.632cfd67.jpg";